import { ethers } from "ethers";

const LOCAL_RPC_PROVIDER = new ethers.providers.JsonRpcProvider(process.env.REACT_APP_KHUGA_JSON_RPC_NODE);

export const getEnsName = async ( address ) => {
    return await LOCAL_RPC_PROVIDER.lookupAddress(address);
}